export const types = [{ value: 'outcome', label: 'Расход' }, { value: 'income', label: 'Приход' }]
